import { render, staticRenderFns } from "./PosSideBar.vue?vue&type=template&id=6894c21c"
import script from "./PosSideBar.vue?vue&type=script&lang=js"
export * from "./PosSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports